import { Plus } from 'lucide-react';
import { SYMPHONY_LOOP_MARKS } from '../../../SymphonyMark';
import { useTranslation } from '../../../../lib/i18n';
import { Card } from '../../ui';
import styles from './mobile.module.css';

/**
 * "No Connectors yet" (Figma 13131-78378): the Maestro mark with a single dashed wire out to a lime
 * "+" node, over the empty-state line. Shown in the Tools section when nothing is connected — the
 * "Available to Connect" list renders below it, so the account still sees where to start.
 */
export function EmptyState() {
  const { t } = useTranslation();
  return (
    <Card className={styles.emptyCard}>
      <svg className={styles.emptyScene} viewBox="0 0 160 96" role="presentation" aria-hidden>
        <circle className={styles.emptyRing} cx="60" cy="48" r="30" pathLength={1} />
        <circle className={styles.emptyRing} cx="60" cy="48" r="44" pathLength={1} />
        <path className={styles.emptyWire} d="M84 34 C104 24 116 24 128 22" strokeDasharray="3 4" />
        <g transform="translate(48,36) scale(1)">
          {SYMPHONY_LOOP_MARKS.map((m, i) => (
            <rect
              key={i}
              className={styles.emptyMark}
              x={m.cx - m.size / 2}
              y={m.cy - m.size / 2}
              width={m.size}
              height={m.size}
              rx={m.rx}
            />
          ))}
        </g>
        <circle className={styles.emptyPlus} cx="132" cy="20" r="9" />
        <path d="M132 16.5v7M128.5 20h7" className={styles.emptyPlusGlyph} strokeLinecap="round" />
      </svg>
      <div className={styles.emptyLabel}>{t('connectors.emptyTitle')}</div>
    </Card>
  );
}
